/** The wheel event fields that decide the zoom step. */
export type WheelInput = { deltaY: number; deltaMode: number; ctrlKey: boolean };

const DELTA_MODE_LINE = 1;
const PIXEL_STEP = 0.002;
const LINE_STEP = 0.05;
const PAGE_STEP = 1;
/** macOS trackpad pinch arrives as ctrl+wheel with small deltas; v11 speeds it up. */
const MAC_PINCH_SPEED = 10;

const stepFor = (deltaMode: number): number => {
  if (deltaMode === 0) return PIXEL_STEP;
  return deltaMode === DELTA_MODE_LINE ? LINE_STEP : PAGE_STEP;
};

/** Factor to multiply the zoom by for one wheel event (v11 behaviour: 2 ^ (−deltaY × step)). */
export const getWheelZoomFactor = ({ deltaY, deltaMode, ctrlKey }: WheelInput, isMacOs: boolean): number => {
  const speed = ctrlKey && isMacOs ? MAC_PINCH_SPEED : 1;
  return 2 ** (-deltaY * stepFor(deltaMode) * speed);
};

/** Double-click zooms in by this factor; with Shift it zooms out by it. */
export const DOUBLE_CLICK_ZOOM_FACTOR = 2;
